import React from "react";
import styled from "styled-components";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
}

const SVG = styled.svg``;

export const IconInfo: React.FC<IProps> = ({color, ...rest}) => (
	<SVG viewBox="0 0 16 16" fill="none" {...rest}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.90851 2.90869C5.72012 0.0970855 10.2795 0.0970855 13.0911 2.90869C15.9027 5.7203 15.9027 10.2797 13.0911 13.0913C10.2795 15.9029 5.72012 15.9029 2.90851 13.0913C0.0969024 10.2797 0.0969024 5.7203 2.90851 2.90869ZM8.7293 6.54099L6.58647 6.54106C6.51083 6.54141 6.43695 6.54352 6.37363 6.55619C6.22165 6.58658 6.14566 6.66257 6.13046 6.78416C6.11526 6.89054 6.19125 7.01212 6.32803 7.05772C6.44962 7.08811 6.5712 7.10331 6.69278 7.11851C6.98154 7.14891 7.07273 7.25529 7.07273 7.54405C7.07273 7.58964 7.05753 7.63524 7.05753 7.68083C6.96634 8.19376 6.87516 8.71524 6.78397 9.23244L6.69278 9.74774L6.51041 10.9332C6.43442 11.5107 6.99674 12.0578 7.43748 12.1186C7.71104 12.1642 7.9694 12.1642 8.24297 12.1642C8.82049 12.1642 9.30682 11.921 9.70196 11.5107C9.76275 11.4499 9.82355 11.3435 9.85394 11.2523C9.89954 11.0852 9.76275 10.9788 9.58038 11.0396C9.474 11.07 9.38281 11.146 9.27642 11.1915C9.13964 11.2523 9.00286 11.2979 8.86608 11.3131C8.6989 11.3283 8.57732 11.2371 8.53173 11.07C8.50133 10.9484 8.48613 10.8116 8.50133 10.69C8.53173 10.4316 8.59252 10.1733 8.63811 9.91492C8.77489 9.12463 8.92687 8.34954 9.06365 7.55925C9.10925 7.34648 9.13964 7.13371 9.13964 6.92094C9.13964 6.67251 8.99913 6.55054 8.75864 6.54153L8.7293 6.54099ZM8.28857 3.82057C7.68065 3.82057 7.17912 4.3069 7.17912 4.91482C7.17912 5.53793 7.68065 6.03946 8.28857 6.03946C8.88129 6.03946 9.38282 5.53793 9.38282 4.93001C9.38282 4.3221 8.89648 3.82057 8.28857 3.82057Z"
			fill={color}
		/>
	</SVG>
);

IconInfo.defaultProps = {
	width: 16,
	height: 16,
	color: "currentColor",
};
